import { AccountCircle } from "@mui/icons-material";
import { Avatar, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { inject } from "../../../../../../../lib/itn-ui-kit/services/service-container";
import useService from "../../../../../../hooks/useService";
import STRINGS from "../../utils/strings";

import Routes from "./Routes";

const InformationHeader = () => {
  const currentUserService = inject("current-user-service");
  const userRepository = useService("repositories/user-repository");
  const [userInfo, setUserInfo] = useState({});
  const userId = currentUserService?.user?.pk;
  const userName = userInfo?.name ?? STRINGS.defaultUserName;
  const userProfilePicture = userInfo?.profilePicture ?? null;

  const fetchUserData = async () => {
    try {
      const data = await userRepository.findRecord(userId);
      setUserInfo(data);
    } catch (error) {
      console.error("Error fetching user data:", error);
      return error;
    }
  };

  useEffect(() => {
    if (!userId || !userRepository) {
      return;
    }
    fetchUserData();
  }, [userId, userRepository]);

  return (
    <div className="flex h-[10%] w-full flex-row justify-between">
      <div className="flex flex-row content-start justify-start">
        <Avatar
          className="m-2 h-[75px] w-[75px] bg-white text-gray-400"
          alt=""
          src={userProfilePicture}
        >
          {userProfilePicture && <AccountCircle className="m-0 h-full w-full bg-white p-0" />}
        </Avatar>
        <div className="flex w-full flex-col py-4">
          <Typography className="p-0 text-base font-semibold text-black">{userName}</Typography>
          <Routes />
        </div>
      </div>
    </div>
  );
};

export default InformationHeader;
